// extracted by mini-css-extract-plugin
export var addToCartButton = "_py-b";
export var arrowButtonContainer = "_py-9";
export var arrowButtonIcon = "_py-a";
export var carouselArrowButton = "_py-6";
export var carouselElementContainer = "_py-1";
export var left = "_py-7";
export var productDisplayCarouselContainer = "_py-0";
export var productTileContainer = "_py-2";
export var productTileImage = "_py-4";
export var productTileImageContainer = "_py-3";
export var productTileTitle = "_py-5";
export var right = "_py-8";
export var sliderOverflow = "_py-c";